import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0 0 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 2rem 0 0 0;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  
  ${(props) => props.theme.breakpoints.up("medium")} {
    width: ${(props) => props.theme.width};
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const TopBlock = Styled.div`
  position: relative;
  width: 100%;
`;

export const BottomBlock = Styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: 78.75rem;
  max-width: 17.1875rem;
  text-align: center;
  z-index: 3;
  gap: 1rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: 25rem;
    gap: 2rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: 63rem;
    transform: translateY(-6.875rem);
  }
`;

export const IllustrationContainer = Styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 22.8125rem;
  box-shadow: rgba(3, 3, 3, 0.1) 0px 2px 20px;

  ${(props) => props.theme.breakpoints.up("medium")} {
    height: 24.375rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    height: 45.625rem;
  }
`;

export const Illustration = Styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`;

export const Gradient = Styled.div`
  position: absolute;
  width: 100%;
  height: calc(50% + 3.125rem);
  top: 50%;
  left: 0px;
  z-index: 2;
  background: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
  pointer-events: none;

  ${(props) => props.theme.breakpoints.up("large")} {
    width: calc(100% + 11.25rem);
    left: -9rem;
  }
`;

export const Message = Styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  z-index: 10;
  left: 50%;
  transform: translateX(-50%);
  top: 16%;
  width: 20.937rem;
  height: calc(84%);
  padding: 3.125rem 1.25rem;
  text-align: center;

  ${(props) => props.theme.breakpoints.up("large")} {
    width: 42.5rem;
    padding: 3.125rem 2.25rem;
    top: 2%;
  }
`;

export const ComparisonIllustrationContainer = Styled.div`
  height: 5rem;
  max-width: 100%;

  ${(props) => props.theme.breakpoints.up("large")} {
    height: 10rem;
  }
`;

export const ComparisonIllustration = Styled.img`
  width: 100%;
  height: 100%;
`;

export const Pitch = Styled.div`
  max-width: 34.375rem;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.624rem;
  letter-spacing: -0.2px;
  text-align: center;

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.624rem;
    line-height: 2rem;
    max-width: 28.75rem;
  }

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
`;

export const BottomBlockIllustrationContainer = Styled.div`
  position: relative;
`;

export const BottomBlockIllustration = Styled.img`
  width: 100%;
  height: 100%;
`;

export const HeadlineContainer = Styled.div`
  max-width: 20.937rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: 25rem;
    gap: 2rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: 63rem;
  }
`;
